const ProfileEnum = Object.freeze({
	PASSWORD: 'password',
	CONFIRM_PASSWORD: 'confirmPassword',
});

export default ProfileEnum;
